import React from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { Progress, Steps, Skeleton, Row, Col, Alert } from "antd";
import { has } from "lodash";

const getIcon = (index, current) => {
	return current === index && { icon: <LoadingOutlined /> };
};
function Initial({ apiTracking, tenant }) {
	const current = has(apiTracking, "current") ? apiTracking["current"] : 0;

	const status = has(apiTracking, "status") ? apiTracking["status"] : "process";

	const errorMessage = has(apiTracking, "error") ? apiTracking["error"] : false;

	const percent = has(apiTracking, `${tenant}-Downloading`) ? apiTracking[`${tenant}-Downloading`] : 0;

	// const percent=  has(apiTracking, `${tenant}-Downloading`) ? apiTracking[`${tenant}-Downloading`] : 0;
	const items = [
		{
			title: "Login",
			...getIcon(0, current)
		},
		{
			title: "Waiting For Server",
			...getIcon(1, current),
			...(current === 1 && { description: "Generate and cache the data. This may take a moment..." })
		},
		{
			title: `Downloading Data`,
			...getIcon(2, current),
			...(percent && {
				description: <Progress percent={percent} strokeColor={{ "0%": "#108ee9", "100%": "#87d068" }} />
			})
		},
		{
			title: "Downloading Config",
			...getIcon(3, current),
			...(current === 3 && { description: "Downloading the configuration data..." })
		},
		{
			title: "Processing Data",
			...getIcon(4, current)
		}
	];
	return (
		<div className="mt-5">
			{errorMessage && (
				<div style={{ marginBottom: "10px", display: "flex", justifyContent: "center" }}>
					<div style={{ width: "50%" }}>
						<Alert message="Error" description={errorMessage} type="error" showIcon />
					</div>
				</div>
			)}

			<div className="pt-3 ">
				<Steps current={current} items={items} status={status} />
			</div>
			<div style={{ marginTop: "2%", display: "flex", justifyContent: "center" }}></div>
			<div>
				<div>
					<Row gutter={16} style={{ marginBottom: "10px" }}>
						<Col span={6}>
							<Skeleton.Input style={{ width: "100%" }} active />
						</Col>
						<Col span={6}>
							<Skeleton.Input style={{ width: "100%" }} active />
						</Col>
						<Col span={6}>
							<Skeleton.Input style={{ width: "100%" }} active />
						</Col>
						<Col span={6}>
							<Skeleton.Input style={{ width: "100%" }} active />
						</Col>
					</Row>
				</div>
				<div style={{ height: "30px" }}></div> {/* Add spacing here */}
				<div style={{ display: "flex", height: "300px", marginTop: "20px" }}>
					{/* Left Column */}
					<div style={{ flex: "70%", marginRight: "10px" }}>
						<Skeleton paragraph={{ rows: 12 }} active />
					</div>

					{/* Right Column */}
					<div style={{ flex: "30%", width: "100%" }}>
						<Skeleton paragraph={{ rows: 8 }} active />
						<div style={{ height: "30px" }}></div>
						<div style={{ width: "100%" }}>
							<div style={{ height: "20%", marginBottom: "10px" }}>
								<div style={{ marginBottom: "10px" }}>
									<Skeleton.Input style={{ width: "100%" }} active />
								</div>
								<div style={{ marginBottom: "10px" }}>
									<Skeleton.Input style={{ width: "100%" }} active />
								</div>
								<div>
									<Skeleton.Input style={{ width: "100%" }} active />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Initial;
